import axios from "axios";
import { appConst } from "../../AppConst";
import { IDonHangCreateRequest } from "../../model/request/ban-hang/IDonHangCreateRequest";
import { IDonHangDoiTraRequest } from "../../model/request/ban-hang/IDonHangDoiTraRequest";
import { ICommonRequest } from "../../model/request/ICommonRequest";
import { IDonHangSearchRequest } from "../../model/request/don-hang/IDonHangSearchRequest";
import { ISendEmailRequest } from "../../model/request/don-hang/SendEmailRequest";
import { apiClient } from "../apiClient";

export const DON_HANG_API_RESOURCE = "don-hang";

export interface IDonHangExportRequest extends ICommonRequest {
  uf_trangthaidonhang_ids?: number[];
  tu_ngay?: string | null;
  den_ngay?: string | null;
}

export const donHangApi = {
  Create: (request: IDonHangCreateRequest) =>
    apiClient.post(`${DON_HANG_API_RESOURCE}`, request),
  GetHtmlPrint: (id: number) =>
    apiClient.get(`${DON_HANG_API_RESOURCE}/${id}/html`),
  GetByHocSinh: (id: number) =>
    apiClient.get(`${DON_HANG_API_RESOURCE}/hoc-sinh/${id}`),
  SelectAll: (payload: ICommonRequest) =>
    apiClient.post(`${DON_HANG_API_RESOURCE}/select-all`, payload),
  Search: (request: IDonHangSearchRequest) =>
    apiClient.post(`${DON_HANG_API_RESOURCE}/search`, request),
  SelectViewDetail: (id: number) =>
    apiClient.get(`${DON_HANG_API_RESOURCE}/detail/${id}`),
  HuyDonHang: (request: { id: number; ly_do_huy: string }) =>
    apiClient.post(`${DON_HANG_API_RESOURCE}/huy-don-hang`, request),
  DoiTraDonHang: (request: IDonHangDoiTraRequest) =>
    apiClient.post(`${DON_HANG_API_RESOURCE}/doi-tra`, request),
  CapNhatDaGiaoHang: (id: number) =>
    apiClient.put(`${DON_HANG_API_RESOURCE}/cap-nhat-da-giao-hang/${id}`),
  SendEmail: (request: ISendEmailRequest) =>
    apiClient.post(`${DON_HANG_API_RESOURCE}/send-email`, request),
  ExportExcel: async (request: IDonHangExportRequest) => {
    const url = `${appConst.baseApiURL}/${DON_HANG_API_RESOURCE}/export-excel`;
    const response = await axios.post(url, request, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${localStorage.access_token}`,
        language: localStorage.getItem("language") || "",
      },
    });

    const contentDisposition = response.headers["content-disposition"] as
      | string
      | undefined;
    const fileNameMatch = contentDisposition?.match(/filename="?([^";]+)"?/i);
    return {
      blob: response.data as Blob,
      fileName: fileNameMatch?.[1] || "danh-sach-don-hang.xlsx",
    };
  },
};
